import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Avatar, Grid, Link, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { ContainedButton } from "../styled/contained-button";

const MAIL_LOGIN_PARAGRAPHS = [
  "Bitte klicken Sie auf den Link, den wir Ihnen eben per E-Mail geschickt haben.",
  "Es kann bis zu 15 Minuten dauern, bis Ihr Handy oder Computer die E-Mail empfangen hat. Dies ist von Gerät zu Gerät unterschiedlich.",
  "Bitte prüfen Sie auch den SPAM-Ordner bzw. das Postfach für „Werbung“ in Ihren E-Mails.",
  "Sollten Sie keine E-Mail erhalten haben, wiederholen Sie den Vorgang und achten Sie bitte darauf, dass Sie Ihre E-Mail-Adresse korrekt eintippen. Alternativ können Sie auch die Anmeldung per Handynummer vornehmen.",
  "Wenn Sie Hilfe benötigen, schreiben Sie uns bitte über unser Kontaktformular eine Nachricht oder rufen Sie in der Sprechstunde an.",
];

const PHONE_LOGIN_PARAGRAPHS = [
  "Bitte klicken Sie auf den Link, den wir Ihnen eben per SMS geschickt haben.",
  "Es kann bis zu 5 Minuten dauern, bis Ihr Handy die SMS empfangen hat.",
  "Sollten Sie keine SMS erhalten haben, wiederholen Sie den Vorgang und achten Sie bitte darauf, dass Sie Ihre Handynummer korrekt eintippen. Alternativ können Sie die Anmeldung auch per E-Mail vornehmen.",
  "Wenn Sie Hilfe benötigen, schreiben Sie uns bitte über unser Kontaktformular eine Nachricht oder rufen Sie in der Sprechstunde an.",
];

export const SignInSecondStep = () => {
  const { option } = useParams();

  const paragraphs =
    option === "phone" ? PHONE_LOGIN_PARAGRAPHS : MAIL_LOGIN_PARAGRAPHS;

  return (
    <Grid
      container
      flexDirection="column"
      spacing={3}
      mt={2}
      sx={{ margin: "auto", width: { xs: "90%", md: "60%" } }}
    >
      <Grid item xs={11} md={12} alignSelf="center">
        <Avatar sx={{ bgcolor: "secondary.main", textAlign: "center" }}>
          <LockOutlinedIcon />
        </Avatar>
      </Grid>

      {paragraphs.map((paragraph) => (
        <Grid key={paragraph} item xs={11} md={12}>
          <Typography variant="body2">{paragraph}</Typography>
        </Grid>
      ))}

      <Grid item xs={11} md={12} width="100%">
        <Link href="https://www.adipositasgutachten.de/kontakt" target="_blank">
          <ContainedButton fullWidth>Zum Kontaktformular</ContainedButton>
        </Link>
      </Grid>
    </Grid>
  );
};
